module.exports = __webpack_public_path__ + "img/batchAddbtn.202b152b.png";